import { PDFExport } from '@progress/kendo-react-pdf';
import { Col, Row } from 'antd';
import moment from 'moment';
import { useRef, useState } from 'react';
import ContentReport from './components/ContentReport/ContentReport';
import SwitchablePicker, { PickerType } from './components/SwitchablePicker/SwitchablePicker';
import style from './PlantReport.module.scss';
export interface PlantReportProps {}

export default function PlantReport(props: PlantReportProps) {
  const pdfExportComponent = useRef<any>(null);
  const [type, setType] = useState<PickerType>('date');
  const [dateTime, setDateTime] = useState<string>(moment().format('YYYY-MM-DD'));
  const handleExportWithComponent = () => {
    pdfExportComponent.current.save();
  };
  return (
    <Row className={style.root}>
      <Row className={style.header}>
        <Col span={8} className={style.left_header}>
          <div className={style.btn_export} onClick={handleExportWithComponent}>
            Export PDF
          </div>
        </Col>
        <Col span={8} className={style.middle_header}>
          REPORT
        </Col>
        <Col span={8} className={style.right_header}>
          <SwitchablePicker
            type={type}
            setDateTime={setDateTime}
            setType={setType}
            dateTime={dateTime}
          />
        </Col>
      </Row>
      <Row className={style.container}>
        <Row className={style.container_pdf_show}>
          <ContentReport isExport={false} dateTime={dateTime} />
        </Row>
        <Row className={style.container_pdf_hidden}>
          <PDFExport paperSize="A4" margin="1cm" ref={pdfExportComponent}>
            <ContentReport isExport={true} dateTime={dateTime} />
          </PDFExport>
        </Row>
      </Row>
    </Row>
  );
}
